import { Injectable, inject } from '@angular/core';
import { of, merge, Observable, of as observableOf } from 'rxjs';
import { catchError, first } from 'rxjs/operators';

import { EcaSecurityService } from '@drc-eca/eca-components-lib';

@Injectable({
  providedIn: 'root'
})
export class DeocsPermissionsService {
  private ecaSecurityService = inject(EcaSecurityService);


  someObservableTrue(...checks: Observable<boolean>[]): Observable<boolean> {
    // on inner observables catch any errors so that if another observables emits true then this method emits true
    const caughtChecks = checks.map((check) => check.pipe(catchError(() => observableOf(false))));

    return merge(...caughtChecks).pipe(
      first((isAllowed) => !!isAllowed === true),
      catchError(() => of(false))
    );
  }

  isAdministrator(): Observable<boolean> {
    return this.ecaSecurityService.userHasPermission('DEOCS:eca-user-management:admin');
  }

  isSurveyAdministrator(): Observable<boolean> {
    return this.ecaSecurityService.userHasPermission('eca-user-profile-service:group:member:deocs:eoa');
  }

  /**
   * The Service should handle restricting the data the logged in user can see (per 'site') so we shouldn't need this (but leaving it here just in case):
   *
   * this._ecaSiteService.getSelectedProduct().pipe(
   *   concatMap((product) => {
   *        return this.sitesForClient(product.id).pipe(
   *          map((results) => `${product.id}:${results.hierarchies[0].id}`)
   *        );
   *      })
   *  ).pipe(
   *    switchMap((productIdhierarchyId) => this.ecaSecurityService.userHasPermission(`${productIdhierarchyId}:public:view`))
   *  )
   */
  canViewApplication(): Observable<boolean> {
    return this.someObservableTrue(
      this.isAdministrator(),
      this.canViewUsers(),
      this.canEditUsers()
    );
  }

  canViewUsers(): Observable<boolean> {
    return this.someObservableTrue(
      this.isAdministrator(),
      this.ecaSecurityService.userHasPermission(`DEOCS:eca-user-management:view`)
    );
  }

  canEditUsers(): Observable<boolean> {
    return this.someObservableTrue(
      this.isAdministrator(),
      this.ecaSecurityService.userHasPermission(`DEOCS:eca-user-management:edit`)
    );
  }
}
